import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconActive(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M13 8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8V16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16V8Z"
        fill="currentColor"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.52 2 22 6.47 22 11.99C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 11.99C2 6.47 6.48 2 12 2ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z"
      />
    </BaseIcon>
  );
}
